// @ts-nocheck
import React from "react";
import CampaignGroupDetail from "src/components/Modules/Campaign/CampaignGroupShow";

const CampaignGroupShow = () => {
  return <CampaignGroupDetail />;
};

export default CampaignGroupShow;
